module.exports = __webpack_public_path__ + "static/media/1.fbff4784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/1.jpg
// module id = 23
// module chunks = 0